var _style, _polygon;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSrStarsGoldLarge(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 115.66 110.12",
    style: {
      enableBackground: "new 0 0 115.66 110.12"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#D2A049;}\r\n")), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "SR Stars-create") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "115.66,40.6 73.52,40.6 57.83,0 42.25,40.6 0,40.6 33.63,68.29 21.74,110.12 57.83,85.51 93.31,109.3  82.23,68.08 "
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSrStarsGoldLarge);
export default __webpack_public_path__ + "static/media/SR_Stars_gold_large.3925b41d8ed7f932254647b372dcf0a5.svg";
export { ForwardRef as ReactComponent };